import React from 'react';
import AutoCarousel from './AutoCarousel';
import Approach from './Approch';
import MyCard from './MyCard';
import InfoCard from './InfoCard';
import ProjectsComponent from './ProjectsComponent';
import ImageParallax from './ImageParallax';
import Team from './Team';
import Platfrom from './Platfrom';


function Home() {
  return (
    <>
      <AutoCarousel></AutoCarousel>
      <Approach></Approach>
      <InfoCard></InfoCard>
      <br></br>
      <MyCard></MyCard>
      <ImageParallax></ImageParallax>
      <br></br>
      <Team></Team>
      <br></br>
      <Platfrom></Platfrom>
      <br></br>
      <ProjectsComponent></ProjectsComponent>
      <br></br>

      
    </>
  );
}

export default Home;
